import axios from 'axios';
import { dispatch } from 'nike-re-framejs';

import { getUrl } from '@/common/oldMobile';
import { optedIn, rewardsLoaded } from '@/tournaments/handlers';
import PopupNg from '@/ui/PopupNg';
import { getObject, setObject } from '@/services/localStorage';
import { paramsSerializer } from '@/_http/utils';
import i18n from '@i18n';

export const loadTournaments = statusRange =>
    axios.get(getUrl('TOURNAMENTS'), {
        params: { statusRange },
        paramsSerializer: paramsSerializer.traditional
    });

export const loadRewards = () =>
    axios.get(getUrl('REWARDS')).then(data => {
        if (data) {
            dispatch(rewardsLoaded(data));
        }
    });

export const optInTournament = tournamentId =>
    axios
        .post(getUrl('TOURNAMENT_OPT_IN').replace('{tournamentId}', tournamentId))
        .then(() => {
            dispatch(optedIn(tournamentId));
            PopupNg.dispatcher.close('Tournaments/RegisterDialog');
        })
        .catch(() => {
            PopupNg.dispatcher.close('Tournaments/RegisterDialog');
            PopupNg.dispatcher.show({
                style: 'error',
                title: i18n('error.unexpected.title'),
                messages: i18n('cl.tournament.failed.login')
            });
        });

export const storeSeenTournaments = tournamentIds => () => setObject('seenTournaments', tournamentIds);

export const loadSeenTournaments = () => getObject('seenTournaments') || [];
